import script from "./AddProjectMemberModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProjectMemberModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddProjectMemberModal.vue?vue&type=style&index=0&id=6e701e34&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e701e34"]])

export default __exports__